<template>
  <div class="video-player">
    <video ref="videoPlayer" class="video-js video-custom-styling"></video>
    <button class="video-player__close" @click="closeVideo">Close</button>
  </div>
</template>

<script>
import videojs from "video.js";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.player.play();

      // Request fullscreen mode for the video element
      if (this.player.requestFullscreen) {
        this.player.requestFullscreen();
      } else if (this.player.webkitRequestFullscreen) {
        this.player.webkitRequestFullscreen();
      } else if (this.player.msRequestFullscreen) {
        this.player.msRequestFullscreen();
      }

      // Event listener for exiting full-screen mode
      document.addEventListener("fullscreenchange", this.handleExitFullscreen);
      document.addEventListener(
        "webkitfullscreenchange",
        this.handleExitFullscreen
      );
      document.addEventListener(
        "mozfullscreenchange",
        this.handleExitFullscreen
      );
      document.addEventListener(
        "MSFullscreenChange",
        this.handleExitFullscreen
      );
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      document.removeEventListener(
        "fullscreenchange",
        this.handleExitFullscreen
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        this.handleExitFullscreen
      );
      document.removeEventListener(
        "mozfullscreenchange",
        this.handleExitFullscreen
      );
      document.removeEventListener(
        "MSFullscreenChange",
        this.handleExitFullscreen
      );
    }
  },
  methods: {
    closeVideo() {
      this.$emit("close-video");
    },
    handleExitFullscreen() {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.mozFullScreenElement &&
        !document.msFullscreenElement
      ) {
        // The video is no longer in full-screen mode, you can hide it here
        this.player.pause(); // Pause the video if needed
        this.$emit("close-video");
      }
    },
  },
};
</script>

<style>
.video-player {
  position: relative; /* Set the position to relative for proper button positioning */
  width: 100%; /* Adjust the width and height of the video player as needed */
  height: 100%;
}

.video-js {
  width: 100%;
  height: 100%;
}

.video-player__close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background-color: var(--color-yellow);
  z-index: 10; /* Ensure the close button appears over the fullscreen mode */
  border-radius: 50%;
  width: 88px;
  height: 88px;

  svg {
    width: 37px;
  }
}
/* Customize the control bar colors */
.video-custom-styling .vjs-control-bar {
  background-color: #000 !important;
}

/* Change the color of the control buttons */
.video-custom-styling .vjs-button:hover .vjs-icon-placeholder:before,
.video-custom-styling .vjs-big-play-button:hover .vjs-icon-placeholder:before {
  //color: yellow; /* Adjust the button hover color */
}

/* Progress bar color */
.video-custom-styling .vjs-progress-holder .vjs-load-progress,
.video-custom-styling .vjs-progress-holder .vjs-play-progress {
  //background-color: yellow; /* Progress bar color */
}

/* Volume slider color */
.video-custom-styling .vjs-volume-level {
  //background-color: yellow; /* Volume slider color */
}

/* Time display color */
.video-custom-styling .vjs-time-control {
  //color: yellow; /* Time display color */
}

/* Fullscreen button */
.vjs-fullscreen-control {
  //color: yellow; /* Fullscreen button color */
}

/* Caption text color */
.vjs-text-track-display {
  //color: yellow; /* Caption text color */
}

/* Adjust the appearance of the play/pause button */
.video-custom-styling .vjs-play-control:before,
.video-custom-styling .vjs-pause-control:before {
  //color: yellow; /* Play/pause button color */
}

/* Custom icon styling */
/* Adjust the styles of your custom icons if needed */
.my-custom-play-toggle {
  //background-image: url(".././assets/logos/cube.svg");
  /* Additional styles */
}
</style>
